module.exports = __webpack_public_path__ + "images/icon/mail_inspector_set-f0cad2fd.svg";